import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import Atomic from "../../../../AComponent/Atomic";
import { getUserId } from "../../../../Utils/Common/Library";

const { Button } = Atomic;

const getStatus = (Workflow) => {
  const appraiseeSteps = (Workflow?.WorkflowSteps || []).filter(
    (w) => w.StepOwnerLabel === "Appraisee"
  );
  if (!appraiseeSteps) return false;
  const appraiseeSubmitStep = appraiseeSteps.find((s) =>
    (s?.AllowedActions || []).includes("Submit")
  );
  if (appraiseeSubmitStep) return true;
  return false;
};

export const calculateAssessmentScore = (
  assessments,
  dimensionRoundingMap,
  flag
) => {
  const { Workflow, Data } = assessments;
  const currentStep = Workflow.WorkflowSteps.find(
    (s) => s.StepOwnerUserIDs[0] === getUserId()
  );
  const { ScoreRounding, RoundingValue } =
    dimensionRoundingMap[Data.DimensionID];
  const stepOwnerLabel = currentStep?.StepOwnerLabel || "";

  if (
    !stepOwnerLabel ||
    (stepOwnerLabel !== "Appraiser" && !getStatus(Workflow))
  )
    return null;

  const { Parameters } = Data;

  let total = 0;
  Parameters.forEach((parameter) => {
    const { Weight, ActorAssessments } = parameter;
    const actorAssessment = ActorAssessments.find(
      (a) => a.ActorType === stepOwnerLabel
    );
    if (actorAssessment) {
      total +=
        parseInt(flag ? 1 : Weight) * parseInt(actorAssessment.Score || "0");
    }
  });
  total =
    ScoreRounding === "RO"
      ? (total / (flag ? Parameters.length : 100)).toFixed(
          parseInt(RoundingValue)
        )
      : total / (flag ? Parameters.length : 100);

  return isNaN(total) ? 0 : total;
};

const calculateAggregate = (
  goalsAssessments,
  coreValuesAssessments,
  goalsScore,
  coreValuesScore,
  dimensionRoundingMap,
  aggregateRounding
) => {
  const goalsWeightage =
    dimensionRoundingMap[goalsAssessments.Data.DimensionID].PlanDimensionWeight;
  const coreValuesWeightage =
    dimensionRoundingMap[coreValuesAssessments.Data.DimensionID]
      .PlanDimensionWeight;

  return (
    (goalsScore * parseInt(goalsWeightage) +
      coreValuesScore * parseInt(coreValuesWeightage)) /
    (parseInt(goalsWeightage) + parseInt(coreValuesWeightage))
  ).toFixed(parseInt(aggregateRounding));
};

const ScorePreview = ({
  goalsAssessments,
  coreValuesAssessments,
  showAggregate,
  aggregateRounding,
  dimensionRoundingMap,
  onConfirm,
  onCancel,
}) => {
  const goalsScore = goalsAssessments
    ? calculateAssessmentScore(goalsAssessments, dimensionRoundingMap)
    : null;
  const coreValuesScore = coreValuesAssessments
    ? calculateAssessmentScore(
        coreValuesAssessments,
        dimensionRoundingMap,
        true
      )
    : null;
  const aggregate =
    showAggregate && goalsScore !== null && coreValuesScore !== null
      ? calculateAggregate(
          goalsAssessments,
          coreValuesAssessments,
          goalsScore,
          coreValuesScore,
          dimensionRoundingMap,
          aggregateRounding
        )
      : null;

  return (
    <Stack rowGap={"1rem"} width={"30vw"} minHeight={"20vh"}>
      <Typography variant="h3">Score Preview</Typography>
      {goalsScore !== null && (
        <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Typography variant="form_h1">Goals Score: </Typography>
          <Typography variant="form_text1">{goalsScore}</Typography>
        </Box>
      )}
      {coreValuesScore !== null && (
        <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Typography variant="form_h1">Core Values: </Typography>
          <Typography variant="form_text1">{coreValuesScore}</Typography>
        </Box>
      )}
      {aggregate !== null && (
        <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Typography variant="form_h1">Aggregate Score: </Typography>
          <Typography variant="form_text1">{aggregate}</Typography>
        </Box>
      )}
      {goalsScore === null && coreValuesScore === null && (
        <Typography variant="form_text2">No Assessments available</Typography>
      )}
      <Box flex={1}></Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <Button label={"Confirm"} onClick={onConfirm} />
        <Button label={"Cancel"} onClick={onCancel} variant={"text"} />
      </Box>
    </Stack>
  );
};

export default ScorePreview;
